import * as types from "./ActionTypes";
import UserApi from "../api/UserApi";

class PersonnelActions {
    constructor () {
    }

    setField (field, value) {
        return { type: types.SET_FIELD, fieldName: field, value };
    }


    setUser (user) {
        return { type: types.SET_USER, user };
    }

    saveUser (user, userPrevState, organization, productRoles) {
        return (dispatch) => {
            if (!user.isValidData()) {
                dispatch({ type: types.USER_INVALID });
                return;
            }
            var productsToRemove = _getProductsToRemove(userPrevState, user.userProducts.map((p) => p.productName));
            var productsToAdd = _getProductsToAdd(userPrevState, user.userProducts.map((p) => p.productName));
            var productsToChangeRole = _getProductsToChangeRole(userPrevState, user, organization, productRoles);

            return UserApi.updateUser(user).then(() => {
                if (productsToRemove.length > 0) {
                    return dispatch(this.removeProducts(user.id, productsToRemove));
                }
                return null;
            }).then(() => {
                if (productsToAdd.length > 0) {
                    return dispatch(this.addProducts(user.id, productsToAdd));
                }
                return null;
            }).then(() => {
                if (productsToChangeRole.length > 0) {
                    UserApi.changeProductsRoles(user.id, productsToChangeRole).catch((erx) => {
                        return dispatch({ type: types.UPDATE_USER_FAILED, error: erx });
                    });
                }
                return null;
            }).then(() => {
                if (userPrevState.isActive != user.isActive) {
                    return dispatch(this.activate(user.id, user.isActive));
                }
                return null;
            }).then((resultUser) => {
                dispatch({ type: types.UPDATE_USER_SUCCEEDED, user: resultUser });
                return user;
            })
                .catch((error) => {
                    dispatch({ type: types.UPDATE_USER_FAILED, error });
                });
        };
    }

    createUser (user, organization) {
        return (dispatch) => {
            if (!user.isValidData()) {
                dispatch({ type: types.USER_INVALID });
                return;
            }

            var createdUser = {};
            var newPass = "";
            return UserApi.generatePassword(organization.id)
                .then((password) => {
                    newPass = password.NewPassword;
                    return UserApi.createUser(user, newPass)
                        .then((newUser) => {
                            createdUser = newUser;
                            var productsToAdd = _getProductsToAdd(createdUser, user.userProducts.map((p) => p.productName));
                            if (productsToAdd.length > 0) {
                                return UserApi.extend(createdUser.id, productsToAdd);
                            }
                            return null;
                        })
                        .then(() => {
                            var productsToRemove = _getProductsToRemove(createdUser, user.userProducts.map((p) => p.productName));
                            if (productsToRemove.length > 0) {
                                return dispatch(this.removeProducts(createdUser.id, productsToRemove));
                            }
                            return null;
                        })
                        .then(() => {
                            var productsToChangeRole = _getProductsToChangeRole(createdUser, user, organization);
                            if (productsToChangeRole.length > 0) {
                                return UserApi.changeProductsRoles(createdUser.id, productsToChangeRole);
                            }
                            return null;
                        })
                        .then(() => {
                            dispatch({ type: types.CREATE_USER_SUCCEEDED, user: createdUser, newPassword: newPass });
                            return createdUser;

                        })
                        .catch((error) => {
                            dispatch({ type: types.CREATE_USER_FAILED, error });
                            //throw(error);
                        });
                }).catch((error) => {
                    dispatch({ type: types.CREATE_USER_FAILED, error });
                    //throw(error);
                });
        };
    }

    removeProducts(userId, products) {
        return (dispatch) => {
            return UserApi.removeProducts(userId, products)
                .then((user) => {
                    return user;
                })
                .catch((error) => {
                    dispatch({ type: types.UPDATE_USER_FAILED, error });
                    throw(error);
                });
        };
    }

    addProducts(userId, products) {
        return (dispatch) => {
            return UserApi.extend(userId, products)
                .then((user) => {
                    return user;
                })
                .catch((error) => {
                    dispatch({ type: types.UPDATE_USER_FAILED, error });
                    throw(error);
                });
        };
    }

    selectProduct (checked, productId) {
        return { type: types.USER_SELECT_PRODUCT, checked, productId };
    }

    selectRole ( productId, roleId, roleName) {
        return { type: types.USER_SELECT_ROLE, productId, roleId, roleName: roleName };
    }

    activate(userId, activate) {
        return (dispatch) => {

            if (activate) {
                return UserApi.activate(userId).then(() => {
                    dispatch({ type: types.ACTIVATE_USER_SUCCEEDED });
                });
            }

            return UserApi.inactivate(userId).then(() => {
                dispatch({ type: types.INACTIVATE_USER_SUCCEEDED });
            });
        };
    }

    resetPassword(userId) {
        return (dispatch) => {
            return UserApi.resetPassword(userId)
                .then((password) => {
                    dispatch({ type: types.RESET_USER_PASSWORD_SUCCEEDED, newPassword: password, userId });
                    return password.NewPassword;
                })
                .catch((error) => {
                    dispatch({ type: types.RESET_USER_PASSWORD_FAILED, error });
                    throw(error);
                });
        };
    }

    setIsActive (isActive) {
        return { type: types.SET_USER_ACTIVE, isActive };
    }
}

const _getProductsToAdd = (user, productNames) => {
    var products = productNames.filter((productName) => {
        if (user.userProducts.find((p) => {return p.productName == productName;}))
            return false;
        return true;
    });

    return products;
};

const _getProductsToRemove = (user, productNames) => {
    const products = user.userProducts.filter((product) => {
        return productNames.indexOf(product.productName) < 0;
    }).map((p) => p.productName);

    return products;
};

const _getProductsToChangeRole = (prevUser, currentUser, organization, productRoles) => {
    return currentUser.userProducts.filter((product) => {
        var p = prevUser.userProducts.find((up) => product.productName === up.productName);

        if (p) {
            return product.roleName && (p.roleName !== product.roleName);
        } else {
            return product.roleName !== _getDefaultRole(productRoles, product.productName);
        }
    });
};

const _getDefaultRole = (productRoles, productName) =>{
    const roles = productRoles.find((p) => p.productName === productName).roles;
    return roles.find(pr => pr.isDefault).name;
};

export default new PersonnelActions();

